// Web module: policies. Policy Center (list with Drata tiles, detail tabs) and the My Compliance employee portal.
// Entities: policy, policy_version, policy_approval, policy_acknowledgment.
// The policy detail uses the generic page (header, Overview with inline edit of owner, renewal date, assignment and
// approval tiers, Mapped records for controls, History, Notes) plus these tabs: Policy, Version history, Approvals and
// Acknowledgments. The contract is in ../README.md.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { appRoute } from '../../app/route-base'
import { lazyComponent } from '../../lib/lazy'
import type { DetailTabProps, WebModule } from '../../lib/modules'

export const myComplianceRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me',
  component: lazyRouteComponent(() => import('./MyCompliancePage'), 'MyCompliancePage'),
})

export const trainingCourseRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/me/training/$course',
  component: lazyRouteComponent(() => import('./TrainingCoursePage'), 'TrainingCoursePage'),
})

export const module: WebModule = {
  routes: [myComplianceRoute, trainingCourseRoute],
  entityOverrides: {
    policy: {
      ListPage: lazyComponent(() => import('./PolicyListPage'), 'PolicyListPage'),
      detailTabs: [
        {
          id: 'policy',
          label: 'Policy',
          order: 15,
          component: lazyComponent<DetailTabProps, 'PolicyTab'>(() => import('./PolicyTab'), 'PolicyTab'),
        },
        {
          id: 'versions',
          label: 'Version history',
          order: 30,
          component: lazyComponent<DetailTabProps, 'VersionsPanel'>(
            () => import('./VersionsPanel'),
            'VersionsPanel',
          ),
        },
        {
          id: 'approvals',
          label: 'Approvals',
          order: 40,
          component: lazyComponent<DetailTabProps, 'ApprovalsPanel'>(
            () => import('./ApprovalsPanel'),
            'ApprovalsPanel',
          ),
        },
        {
          id: 'acknowledgments',
          label: 'Acknowledgments',
          order: 50,
          component: lazyComponent<DetailTabProps, 'AcknowledgmentsPanel'>(
            () => import('./AcknowledgmentsPanel'),
            'AcknowledgmentsPanel',
          ),
        },
      ],
    },
  },
}
